import React from 'react';
import PropTypes from 'prop-types';

const VerificationSuite = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M19.392 11.6704V16.5664C19.3921 16.8861 19.3297 17.2026 19.2081 17.4979C19.0866 17.7932 18.9084 18.0616 18.6837 18.2876C18.459 18.5136 18.1922 18.6929 17.8986 18.8151C17.605 18.9374 17.2903 19.0002 16.9726 19.0001H16.3429C16.9223 19.0001 16.9771 17.3343 16.9714 16.5664V14.1052C16.9717 13.4597 17.2267 12.8408 17.6803 12.3843C18.134 11.9278 18.7492 11.671 19.3909 11.6704H19.392Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.26056 0.5C8.26056 1.14575 8.00554 1.76504 7.55159 2.22165C7.09765 2.67826 6.48197 2.93479 5.83999 2.93479H3.42056V3.31414C3.42056 3.31414 3.28571 0.5 4.03999 0.5H8.26056Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M16.3429 19H1V2.93479C1 2.28904 1.25502 1.66974 1.70897 1.21313C2.16291 0.756521 2.7786 0.5 3.42057 0.5L4.04 0.5C3.28571 0.5 3.42057 3.31414 3.42057 3.31414V16.5664H16.9714C16.9771 17.3343 16.9223 19 16.3429 19Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M2.18971 6.57666L2.224 6.61C2.15403 6.6148 2.08451 6.62479 2.016 6.63989C2.12228 6.59275 2.18971 6.57666 2.18971 6.57666Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M13.04 9.46668L11.712 7.30204C11.6013 7.1208 11.5664 6.90284 11.6151 6.69582C11.6637 6.4888 11.7918 6.30957 11.9714 6.1973L13.0629 5.51791L13.7154 6.58011L18.0149 3.94875C18.132 3.87613 18.2622 3.82744 18.398 3.80547C18.5338 3.7835 18.6727 3.78868 18.8065 3.82071C18.9403 3.85274 19.0666 3.91099 19.178 3.99213C19.2895 4.07328 19.3839 4.17573 19.456 4.29362L20 5.17764L13.04 9.46668Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.57143 6.01797L8.07886 5.12476C7.91913 4.77888 7.8969 4.38466 8.01673 4.02284C8.13657 3.66101 8.38939 3.35896 8.72343 3.17854C9.69486 2.65204 11.0651 1.83929 12.1931 0.906991L12.3817 0.751799C12.5495 0.613181 12.7581 0.534199 12.9751 0.527131C13.1921 0.520063 13.4054 0.585304 13.5817 0.712714L13.7794 0.85526C14.3874 1.29554 16.2 2.51179 17.2491 2.85206C16.8034 4.24649 15.1817 4.67413 13.9349 3.91311C13.6149 3.71769 13.3189 3.52571 13.0663 3.35902C11.6499 4.37852 10.1456 5.26839 8.57143 6.01797Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M9.88571 2.52087C9.856 2.7209 8.67771 8.62163 13.1246 11.0173C14.0088 10.5965 14.8102 10.0186 15.4903 9.31137C15.9156 8.84235 16.4674 8.50778 17.0783 8.34838C17.6892 8.18898 18.333 8.21163 18.9314 8.41356L19.0069 8.44C17.7337 12.1658 13.6434 13.651 13.4697 13.7131L12.9314 13.9039L12.4286 13.6337C9.85714 12.2577 8.14286 10.0413 7.46743 7.22491C7.46743 7.22491 6.12228 3.18417 9.88571 2.52087Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
    <defs>
      <clipPath id="clip0_5439_2482">
        <rect
          width="19"
          height="18.5"
          fill="white"
          transform="translate(1 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

VerificationSuite.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default VerificationSuite;
